const LanguageSkillLevels: string[] = [
  "BASIC",
  "LIMITED",
  "GOOD",
  "EXCELLENT",
  "NATIVE",
];

export default LanguageSkillLevels;
